import { toUTCISOString } from "../utils/formatters";

export const url = process.env.REACT_APP_API_URL; //"https://localhost:8000"//"https://api.usevixo.com";

/** Event raised when the backend refuses an operation for lack of balance. */
export const INSUFFICIENT_FUNDS_EVENT = 'vixo:insufficient-funds';

/**
 * Module-scoped `fetch` that announces 402s, shadowing the global for every
 * call in this file.
 *
 * Any AI endpoint can refuse for lack of balance, and each one should raise the
 * same top-up dialog. Doing that per call site would mean editing every
 * function here and remembering it for every future one -- and the one that
 * gets forgotten is the one that shows a user a raw error. Catching it at the
 * single point all of them already go through makes the handling automatic.
 *
 * The response is cloned before reading, so callers still get an unconsumed
 * body.
 */
const fetch = async (...args) => {
    // Read window.fetch at CALL time, never at module load. App installs an
    // impersonation wrapper on window.fetch from an effect, which runs long
    // after this module is evaluated -- capturing the function up here pinned
    // the native one, and every call in this file then went around the wrapper
    // and silently dropped the X-Impersonate-* headers, leaving an admin who
    // had "started" a session still looking at their own account.
    const response = await window.fetch(...args);

    if (response.status === 402) {
        try {
            const body = await response.clone().json();
            window.dispatchEvent(new CustomEvent(INSUFFICIENT_FUNDS_EVENT, {
                detail: body?.detail || body
            }));
        } catch (e) {
            // A 402 with an unreadable body is still a 402 worth surfacing.
            window.dispatchEvent(new CustomEvent(INSUFFICIENT_FUNDS_EVENT, { detail: {} }));
        }
    }

    return response;
};

export const GetLinkStatus = async (idToken) => {
    const response = await fetch(url + '/UserChannel/linkstatus', {
        method: 'GET',
        headers: {
        'Content-Type': 'application/json',
        'AccessToken' : idToken
        }
    })
    
    const myJson = await response.json(); //extract JSON from the http response
    // do something with myJson

    var status = response.status;
    return {status, myJson};
}

export const LinkGoogle = async (idToken) => {
    const response = await fetch(url + '/UserChannel/LinkGoogle', {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        'AccessToken' : idToken
        }
    })

    const myJson = await response.json(); //extract JSON from the http response
    // do something with myJson

    var status = response.status;
    return {status, myJson};
}

export const UnlinkGoogle = async (idToken) => {
    const response = await fetch(url + '/UserChannel/UnlinkGoogle', {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        'AccessToken' : idToken
        }
    })

    const myJson = await response.json(); //extract JSON from the http response
    // do something with myJson

    var status = response.status;
    return {status, myJson};
} 

export const LinkTikTok = async (idToken) => {
    const response = await fetch(url + '/UserChannel/LinkTikTok', {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        'AccessToken' : idToken
        }
    })

    const myJson = await response.json(); //extract JSON from the http response
    // do something with myJson

    var status = response.status;
    return {status, myJson};
}

export const UnlinkTikTok = async (idToken) => {
    const response = await fetch(url + '/UserChannel/UnlinkTikTok', {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        'AccessToken' : idToken
        }
    })

    const myJson = await response.json(); //extract JSON from the http response
    // do something with myJson

    var status = response.status;
    return {status, myJson};
}

export const LinkFacebook = async (idToken) => {
    const response = await fetch(url + '/UserChannel/LinkFacebook', {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        'AccessToken' : idToken
        }
    })

    const myJson = await response.json();
    var status = response.status;
    return {status, myJson};
}

export const UnlinkFacebook = async (idToken) => {
    const response = await fetch(url + '/UserChannel/UnlinkFacebook', {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        'AccessToken' : idToken
        }
    })

    const myJson = await response.json();
    var status = response.status;
    return {status, myJson};
}

export const LinkInstagram = async (idToken) => {
    const response = await fetch(url + '/UserChannel/LinkInstagram', {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        'AccessToken' : idToken
        }
    })

    const myJson = await response.json();
    var status = response.status;
    return {status, myJson};
}

// Finishes a channel link that the OAuth callback parked. The backend only
// completes it when the signed-in user is the one who started the flow, so this
// call is what actually proves who is linking.
export const CompleteChannelLink = async (idToken, linkToken) => {
    const response = await fetch(url + '/UserChannel/CompleteLink', {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        'AccessToken' : idToken
        },
        body: JSON.stringify({ LinkToken: linkToken })
    })

    const myJson = await response.json();
    var status = response.status;
    return {status, myJson};
}

export const UnlinkInstagram = async (idToken) => {
    const response = await fetch(url + '/UserChannel/UnlinkInstagram', {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        'AccessToken' : idToken
        }
    })

    const myJson = await response.json();
    var status = response.status;
    return {status, myJson};
}

export const getChannelList = async (idToken) => {
    const response = await fetch(url + '/UserChannel/ListChannels', {
        method: 'GET',
        headers: {
        'Content-Type': 'application/json',
        'AccessToken' : idToken
        }
    })
    
    const myJson = await response.json(); //extract JSON from the http response
    // do something with myJson

    var status = response.status;
    return {status, myJson};
}

export const GetPostUploadURL = async (idToken, postId) => {
    const response = await fetch(url + `/post/${postId}/GetVideoUploadURL`, {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        'AccessToken' : idToken
        },
        //body: JSON.stringify({ PostId: postId })
    })

    const myJson = await response.json(); //extract JSON from the http response
    // do something with myJson

    var status = response.status;
    return {status, myJson};
}

export const GetThumbnailUploadURL = async (idToken, postId) => {
    const response = await fetch(url + `/post/${postId}/GetThumbnailUploadURL`, {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        'AccessToken' : idToken
        }
    })

    const myJson = await response.json(); //extract JSON from the http response
    // do something with myJson

    var status = response.status;
    return {status, myJson};
}

export const StartPost = async (idToken) => {
    const response = await fetch(url + '/StartPost', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json(); //extract JSON from the http response
    // do something with myJson

    var status = response.status;
    return {status, myJson};
}

export const UpdatePost = async (idToken, post) => {
    const response = await fetch(url + '/Post', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        },
        body: JSON.stringify(post)
    });
    const myJson = await response.json(); //extract JSON from the http response
    // do something with myJson
    var status = response.status;   
    return {status, myJson};

}

export const GetPost = async (idToken, postId) => {
    const response = await fetch(url + `/Post/${postId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json(); //extract JSON from the http response
    // do something with myJson

    var status = response.status;
    return {status, myJson};
}

// Publish status + latest metrics for one post. Preferred over scanning
// GetPostList, which caps a page at 10 server-side however many you ask for.
export const GetPostReport = async (idToken, postId) => {
    const response = await fetch(url + `/Post/${postId}/report`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json();
    var status = response.status;
    return {status, myJson};
}

export const AnalyzePostMetrics = async (idToken, postId) => {
    const response = await fetch(url + `/Post/${postId}/AnalyzeMetrics`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json();
    var status = response.status;
    return {status, myJson};
}

export const GetPostList = async (idToken, pageDefinition) => {
    const response = await fetch(url + '/post/list', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        },
        body: JSON.stringify(pageDefinition)
    });

    const myJson = await response.json(); //extract JSON from the http response
    // do something with myJson

    var status = response.status;
    return {status, myJson};
}

export const DeletePost = async (idToken, postId) => {
    const response = await fetch(url + `/post/${postId}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json(); //extract JSON from the http response
    // do something with myJson

    var status = response.status;
    return {status, myJson};
}

export const GetPostInCalendarMonth = async (idToken, startDate, endDate) => {
    // Convert dates to UTC ISO strings for the API
    const startDateUTC = toUTCISOString(startDate);
    const endDateUTC = toUTCISOString(endDate);
    
    const response = await fetch(url + '/post/calendar', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        },
        body: JSON.stringify({ 
            StartDate: startDateUTC, 
            EndDate: endDateUTC 
        })
    });

    const myJson = await response.json(); //extract JSON from the http response
    // do something with myJson

    var status = response.status;
    return { status, myJson };
}

export const UploadFile = async (uploadUrl, file, contentType = null) => {
    const headers = {};
    if (contentType) {
        headers['Content-Type'] = contentType;
    }
    else {
        headers['Content-Type'] = file.type;
    }
    
    const response = await fetch(uploadUrl, {
        method: 'PUT',
        headers: headers,
        body: file
    });

    if (!response.ok) {
        throw new Error(`Failed to upload file: ${response.statusText}`);
    }

    return response;
}

// Post Variations API methods

export const CreateUpdatePostVariation = async (idToken, postVariation) => {
    const response = await fetch(url + '/postvariations', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        },
        body: JSON.stringify(postVariation)
    });

    const myJson = await response.json(); //extract JSON from the http response
    // do something with myJson

    var status = response.status;
    return {status, myJson};
}

export const GetPostVariation = async (idToken, variationId) => {
    const response = await fetch(url + `/postvariations/${variationId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json(); //extract JSON from the http response
    // do something with myJson

    var status = response.status;
    return {status, myJson};
}

export const DeletePostVariation = async (idToken, variationId) => {
    const response = await fetch(url + `/postvariations/${variationId}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json(); //extract JSON from the http response
    // do something with myJson

    var status = response.status;
    return {status, myJson};
}

export const GetPostVariationsList = async (idToken, pageDefinition) => {
    const response = await fetch(url + '/postvariations/list', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        },
        body: JSON.stringify(pageDefinition)
    });

    const myJson = await response.json(); //extract JSON from the http response
    // do something with myJson

    var status = response.status;
    return {status, myJson};
}

// How a variation performed against the equally long period before it ran.
export const GetPostVariationResult = async (idToken, variationId) => {
    const response = await fetch(url + `/postvariations/${variationId}/result`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json();
    var status = response.status;
    return {status, myJson};
}

// Keep a winning variation's copy as the post's own and end the experiment.
export const PromotePostVariation = async (idToken, variationId) => {
    const response = await fetch(url + `/postvariations/${variationId}/promote`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json();
    var status = response.status;
    return {status, myJson};
}

export const GetPostVariationThumbnailUploadURL = async (idToken, postVariationId) => {
    const response = await fetch(url + `/postvariations/${postVariationId}/GetThumbnailUploadURL`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json(); //extract JSON from the http response
    // do something with myJson

    var status = response.status;
    return {status, myJson};
}

// Fetch scorecard for a post variation and user channel
export const getPostVariationScorecard = async (idToken, variationId, channelId, channelType) => {
    const response = await fetch(url + '/postvariations/Scorecard', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        },
        body: JSON.stringify({
            VariationId: variationId,
            ChannelId: channelId,
            ChannelType: channelType
        })
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

// Video Workspace API methods

export const CreateVideoWorkspace = async (idToken) => {
    const response = await fetch(url + '/VideoWorkspace/Create', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

export const GetVideoWorkspace = async (idToken, videoWorkspaceId) => {
    const response = await fetch(url + `/VideoWorkspace/${videoWorkspaceId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

export const UpdateVideoWorkspace = async (idToken, videoWorkspaceId, videoWorkspace) => {
    const response = await fetch(url + `/VideoWorkspace/${videoWorkspaceId}`, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        },
        body: JSON.stringify(videoWorkspace)
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

export const DeleteVideoWorkspace = async (idToken, videoWorkspaceId) => {
    const response = await fetch(url + `/VideoWorkspace/${videoWorkspaceId}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

export const GetVideoWorkspaceList = async (idToken, pageDefinition) => {
    const response = await fetch(url + '/VideoWorkspaceList', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        },
        body: JSON.stringify(pageDefinition)
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

export const GetVideoWorkspaceEditorList = async (idToken, pageDefinition) => {
    const response = await fetch(url + '/VideoWorkspaceEditorList', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        },
        body: JSON.stringify(pageDefinition)
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

// Video Workspace Assets API methods

export const GetVideoWorkspaceUploadUrl = async (idToken, uploadRequest) => {
    const response = await fetch(url + '/VideoWorkspace/GetUploadUrl', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        },
        body: JSON.stringify(uploadRequest)
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

// Progress of a chunked upload, reported as it goes so every viewer of the
// workspace sees the bar move and an abandoned upload can be told apart from
// a live one.
export const ReportVideoWorkspaceUploadProgress = async (idToken, progressRequest) => {
    const response = await fetch(url + '/VideoWorkspace/UploadProgress', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        },
        body: JSON.stringify(progressRequest)
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

// Where storage says an upload stands, with the session to continue it.
export const GetVideoWorkspaceUploadStatus = async (idToken, statusRequest) => {
    const response = await fetch(url + '/VideoWorkspace/UploadStatus', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        },
        body: JSON.stringify(statusRequest)
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

export const GetVideoWorkspaceAssetUrl = async (idToken, assetRequest) => {
    const response = await fetch(url + '/VideoWorkspace/GetAssetUrl', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        },
        body: JSON.stringify(assetRequest)
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

export const ApplyVideoWorkspaceBlocks = async (idToken, videoWorkspaceId, blocks, mediaInfo) => {
    const response = await fetch(url + `/VideoWorkspace/${videoWorkspaceId}/ApplyBlocks`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        },
        body: JSON.stringify({ blocks, mediaInfo })
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

export const SuggestVideoWorkspaceBlocks = async (idToken, videoWorkspaceId, sourceFileName, mediaInfo, goal = '') => {
    const response = await fetch(url + `/VideoWorkspace/${videoWorkspaceId}/SuggestBlocks`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        },
        body: JSON.stringify({ sourceFileName, mediaInfo, goal })
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

export const ListVideoWorkspaceAssets = async (idToken, videoWorkspaceId) => {
    const response = await fetch(url + `/VideoWorkspace/ListAssets?VideoWorkspaceId=${videoWorkspaceId}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

export const GenerateVideoWorkspaceAsset = async (idToken, generateAssetRequest) => {
    const response = await fetch(url + '/VideoWorkspace/GenerateAsset', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        },
        body: JSON.stringify(generateAssetRequest)
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

// Video Workspace Processing API methods

export const ProcessVideo = async (idToken, videoWorkspaceProcessRequest) => {
    const response = await fetch(url + '/VideoWorkspace/ProcessVideo', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        },
        body: JSON.stringify(videoWorkspaceProcessRequest)
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

// The edit in progress, saved between visits so a refresh does not throw the
// cut away. The graph is the same `layered_timeline_v1` shape the editor and
// the AI planner both speak.
export const SaveVideoWorkspaceTimeline = async (idToken, videoWorkspaceId, graph) => {
    const response = await fetch(url + `/VideoWorkspace/${videoWorkspaceId}/Timeline`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        },
        body: JSON.stringify({ VideoWorkspaceId: videoWorkspaceId, Graph: graph })
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

export const GetVideoWorkspaceTimeline = async (idToken, videoWorkspaceId) => {
    const response = await fetch(url + `/VideoWorkspace/${videoWorkspaceId}/Timeline`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

// Measuring how far apart several cameras of one take were started. Decoding
// their audio is worker work, so this queues it and the status is polled.
export const QueueAudioAlignment = async (idToken, videoWorkspaceId, fileNames, referenceFileName) => {
    const response = await fetch(url + '/VideoWorkspace/AlignAudio', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        },
        body: JSON.stringify({
            VideoWorkspaceId: videoWorkspaceId,
            FileNames: fileNames,
            ReferenceFileName: referenceFileName || '',
        })
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

export const GetAudioAlignment = async (idToken, videoWorkspaceId) => {
    const response = await fetch(url + `/VideoWorkspace/AlignAudio/${videoWorkspaceId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

export const GetProcessStatus = async (idToken, videoWorkspaceId) => {
    const response = await fetch(url + `/VideoWorkspace/ProcessStatus/${videoWorkspaceId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

// Get output URL by version
export const GetVideoWorkspaceOutputUrl = async (idToken, videoWorkspaceId, version) => {
    const response = await fetch(url + `/Videoworkspace/${videoWorkspaceId}/GetOutputUrl/${version}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

// Get output upload URL
export const GetVideoWorkspaceOutputUploadUrl = async (idToken, videoWorkspaceId) => {
    const response = await fetch(url + `/Videoworkspace/${videoWorkspaceId}/GetOutputUploadUrl`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

// Finalize version
export const FinalizeVideoWorkspaceVersion = async (idToken, videoWorkspaceId) => {
    const response = await fetch(url + `/Videoworkspace/${videoWorkspaceId}/finalizeVersion`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

// Finalize uploaded output for current draft version
export const FinalizeVideoWorkspaceUpload = async (idToken, videoWorkspaceId) => {
    const response = await fetch(url + `/Videoworkspace/${videoWorkspaceId}/finalizeUpload`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

// Get version history
export const GetVideoWorkspaceVersionHistory = async (idToken, videoWorkspaceId) => {
    const response = await fetch(url + `/Videoworkspace/${videoWorkspaceId}/versions`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

// Video Workspace Comments API methods

export const AddUpdateVideoWorkspaceComment = async (idToken, comment) => {
    const response = await fetch(url + '/VideoWorkspace/Comment', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        },
        body: JSON.stringify(comment)
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

export const GetVideoWorkspaceComments = async (idToken, videoWorkspaceId) => {
    const response = await fetch(url + `/VideoWorkspace/${videoWorkspaceId}/Comments`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

export const DeleteVideoWorkspaceComment = async (idToken, commentId) => {
    const response = await fetch(url + `/VideoWorkspace/Comment/${commentId}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

export const QueueVideoWorkspaceReview = async (idToken, reviewRequest) => {
    const response = await fetch(url + '/VideoWorkspace/ReviewQueue', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        },
        body: JSON.stringify(reviewRequest)
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

export const GetVideoWorkspaceReviewStatus = async (idToken, videoWorkspaceId) => {
    const response = await fetch(url + `/VideoWorkspace/ReviewStatus/${videoWorkspaceId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

// WebSocket streaming for video differences
export const createVideoWorkspaceStreamingConnection = (videoWorkspaceId, version1, version2) => {
    const wsUrl = url.replace('http', 'ws').replace('https', 'wss') + 
                 `/VideoSpace/DifferenceStream/${videoWorkspaceId}/${version1}/${version2}`;

    return new WebSocket(wsUrl);
};

// Agentic AI WebSocket connection for video workspace processing
export const createVideoWorkspaceAIConnection = (videoWorkspaceId) => {
    const wsUrl = url.replace('http', 'ws').replace('https', 'wss') + 
                 `/VideoWorkspace/Process/${videoWorkspaceId}`;

    return new WebSocket(wsUrl);
};

// Analysis status is polled through the existing GetAnalysisStatus below. The
// WebSocket that used to stream it was a server-side Firestore poll on a 30s
// timer piped down a held-open socket -- slower than simply asking, and it
// pinned a Cloud Run instance for the length of the analysis.

// Queue an analysis whose upload has landed. Was a `finalize` message on the
// status socket, which is why the client used to wait for a socket to open
// before it could start the work.
export const FinalizeAnalysis = async (idToken, analysisId) => {
    const response = await fetch(url + `/FinalizeAnalysis/${analysisId}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

// WebSocket connection for ideation AI refinement chat
export const createIdeationAIConnection = (ideaId) => {
    const wsUrl = url.replace('http', 'ws').replace('https', 'wss') +
                 `/Ideation/ChatStream/${encodeURIComponent(ideaId)}`;

    return new WebSocket(wsUrl);
};

// User API methods
export const GetCurrentUser = async (idToken) => {
    const response = await fetch(url + '/User/Me', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json();
    var status = response.status;
    return {status, myJson};
};

export const GetPostThumbnailURL = async (idToken, postId) => {
    const response = await fetch(url + `/post/${postId}/GetThumbnailURL`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json();
    var status = response.status;
    return {status, myJson};
};

export const GetUser = async (idToken, userName) => {
    const response = await fetch(url + `/User/${userName}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json();
    var status = response.status;
    return {status, myJson};
};

export const CreateOrUpdateUser = async (idToken, user) => {
    const response = await fetch(url + '/User', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        },
        body: JSON.stringify(user)
    });

    const myJson = await response.json();
    var status = response.status;
    return {status, myJson};
};

export const GetUserBasicInfo = async (idToken, username) => {
    const response = await fetch(url + `/User/${username}/BasicInfo`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json();
    var status = response.status;
    return {status, myJson};
};

export const MarkPaymentSetup = async (idToken, sessionId = null) => {
    const querySuffix = sessionId ? `?session_id=${encodeURIComponent(sessionId)}` : '';
    const response = await fetch(url + '/User/MarkPaymentSetup' + querySuffix, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json();
    var status = response.status;
    return {status, myJson};
};

export const CreatePaymentSetupSession = async (idToken) => {
    const response = await fetch(url + '/User/CreatePaymentSetupSession', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json();
    var status = response.status;
    return {status, myJson};
};

export const GetBillingSummary = async (idToken, startDate = null, endDate = null) => {
    const queryParams = new URLSearchParams();
    if (startDate) {
        queryParams.append('start_date', startDate);
    }
    if (endDate) {
        queryParams.append('end_date', endDate);
    }

    const querySuffix = queryParams.toString() ? `?${queryParams.toString()}` : '';

    const response = await fetch(url + '/User/Billing/Summary' + querySuffix, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json();
    var status = response.status;
    return {status, myJson};
};

export const GetWalletBalance = async (idToken) => {
    const response = await fetch(url + '/User/Wallet', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json();
    var status = response.status;
    return {status, myJson};
};

/**
 * One page of balance movements, newest first.
 *
 * Pass the previous response's `next_cursor` to get the page below it; a null
 * `next_cursor` (or `has_more: false`) means there is nothing further to load.
 */
export const GetWalletLedger = async (idToken, limit = 50, cursor = null) => {
    const query = `?limit=${limit}` + (cursor ? `&cursor=${encodeURIComponent(cursor)}` : '');
    const response = await fetch(url + '/User/Wallet/Ledger' + query, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json();
    var status = response.status;
    return {status, myJson};
};

/**
 * What an AI operation would cost, asked before starting it.
 *
 * `body` is { entity_flow, ...sizes }: shot_count/seconds_per_shot for video
 * generation, prompt_text/call_count for the LLM flows. The response carries
 * `requires_confirmation`, which is the server's decision, not the caller's --
 * the threshold lives in one place so a component cannot quietly stop asking.
 */
export const EstimateCost = async (idToken, body) => {
    const response = await fetch(url + '/Cost/Estimate', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        },
        body: JSON.stringify(body)
    });

    const myJson = await response.json();
    var status = response.status;
    return {status, myJson};
};

/**
 * Cost of a generation phase, priced from the stored run rather than from
 * anything the browser knows: the quote is then exactly the reservation the
 * matching Generate call will place.
 */
export const EstimateGenerationPhase = async (idToken, workspaceId, params = {}) => {
    const query = new URLSearchParams(
        Object.entries(params).filter(([, value]) => value !== null && value !== undefined)
    ).toString();
    const response = await fetch(url + `/VideoGeneration/${workspaceId}/Estimate?${query}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json();
    var status = response.status;
    return {status, myJson};
};

/**
 * Credit a completed Checkout payment without waiting for the webhook, which
 * cannot be delivered to a local machine. Refused (404) outside local
 * development, where the webhook is the authority rather than a convenience.
 */
export const ClaimTopUp = async (idToken, sessionId) => {
    const response = await fetch(url + '/User/Wallet/TopUp/Claim', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        },
        body: JSON.stringify({ session_id: sessionId })
    });

    const myJson = await response.json();
    var status = response.status;
    return {status, myJson};
};

/** Add balance without paying. Refused (404) outside local development. */
export const AddLocalWalletCredit = async (idToken, amountUsd) => {
    const response = await fetch(url + '/User/Wallet/LocalCredit', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        },
        body: JSON.stringify({ amount_usd: amountUsd })
    });

    const myJson = await response.json();
    var status = response.status;
    return {status, myJson};
};

export const CreateTopUpSession = async (idToken, amountUsd) => {
    const response = await fetch(url + '/User/Wallet/TopUp', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        },
        body: JSON.stringify({ amount_usd: amountUsd })
    });

    const myJson = await response.json();
    var status = response.status;
    return {status, myJson};
};

export const AnalyzeVideo = async (idToken, videoUrl, videoId, llmProvider = 'anthropic', includeDetailedReport = true) => {
    const response = await fetch(url + '/AnalyzeVideo', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        },
        body: JSON.stringify({
            video_url: videoUrl,
            video_id: videoId,
            llm_provider: llmProvider,
            include_detailed_report: includeDetailedReport
        })
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

export const GetAllAnalyses = async (idToken) => {
    const response = await fetch(url + '/GetAllAnalyses', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

export const GetAnalysisById = async (idToken, analysisId) => {
    const response = await fetch(url + '/GetAnalysisResults/' + analysisId, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

// ============================================================================
// NEW WORKFLOW: Create Analysis -> Upload to GCS -> Start Analysis -> Poll Status
// ============================================================================

export const CreateAnalysis = async (
    idToken,
    filename,
    fileType = 'video/mp4',
    llmProvider = 'anthropic',
    isTranscript = false
) => {
    const response = await fetch(url + '/CreateAnalysis', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        },
        body: JSON.stringify({
            filename: filename,
            file_type: fileType,
            llm_provider: llmProvider,
            is_transcript: isTranscript
        })
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

export const GetAnalysisStatus = async (idToken, analysisId) => {
    const response = await fetch(url + '/AnalysisStatus/' + analysisId, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

export const DeleteAnalysis = async (idToken, analysisId) => {
    const response = await fetch(url + '/DeleteAnalysis/' + analysisId, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

export const GetAdminBillingSummary = async (idToken, startDate = '', endDate = '') => {
    const params = new URLSearchParams();
    if (startDate) params.set('start_date', startDate);
    if (endDate) params.set('end_date', endDate);
    const qs = params.toString();
    const response = await fetch(url + '/billing/summary' + (qs ? `?${qs}` : ''), {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

export const GetAdminServiceHealth = async (idToken) => {
    const response = await fetch(url + '/admin/service-health', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

export const GetAdminBusinessHealth = async (idToken, startDate = '', endDate = '') => {
    const params = new URLSearchParams();
    if (startDate) params.set('start_date', startDate);
    if (endDate) params.set('end_date', endDate);
    const qs = params.toString();
    const response = await fetch(url + '/admin/business-health' + (qs ? `?${qs}` : ''), {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

export const ResolveUserIdByEmail = async (idToken, email) => {
    const response = await fetch(url + '/resolve-user-id?email=' + encodeURIComponent(email), {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

export const GetAdminUserWallet = async (idToken, userId) => {
    const response = await fetch(url + '/admin/wallet/' + encodeURIComponent(userId), {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

// action is 'credit' | 'debit'. Both take the same body; the server decides what
// each one means and writes the ledger entry that records it.
export const AdminAdjustWallet = async (idToken, userId, action, amountUsd, reason) => {
    const response = await fetch(url + '/admin/wallet/' + encodeURIComponent(userId) + '/' + action, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        },
        body: JSON.stringify({ amount_usd: Number(amountUsd), reason: String(reason || '') })
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

// expectedRefundUsd is what the operator was shown. The server refuses the
// refund if the figure has moved since, so a stale page cannot refund a number
// nobody actually saw.
export const AdminRefundWallet = async (idToken, userId, reason, expectedRefundUsd) => {
    const response = await fetch(url + '/admin/wallet/' + encodeURIComponent(userId) + '/refund', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        },
        body: JSON.stringify({ reason: String(reason || ''), expected_refund_usd: Number(expectedRefundUsd) })
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

export const ListIdeationIdeas = async (idToken, lastIdeaId = '', pageSize = 25) => {
    const params = new URLSearchParams();
    if (lastIdeaId) {
        params.append('last_idea_id', lastIdeaId);
    }
    if (pageSize) {
        params.append('page_size', String(pageSize));
    }

    const querySuffix = params.toString() ? ('?' + params.toString()) : '';
    const response = await fetch(url + '/Ideation/List' + querySuffix, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

export const GetIdeationIdea = async (idToken, ideaId) => {
    const response = await fetch(url + '/Ideation/' + encodeURIComponent(ideaId), {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

export const UpsertIdeationIdea = async (idToken, payload) => {
    const response = await fetch(url + '/Ideation/Upsert', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        },
        body: JSON.stringify(payload || {})
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

export const DeleteIdeationIdea = async (idToken, ideaId) => {
    const response = await fetch(url + '/Ideation/' + encodeURIComponent(ideaId), {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

export const AnalyzeTranscript = async (
    idToken,
    transcript,
    llmProvider = 'anthropic',
    includeDetailedReport = true,
    entity = null
) => {
    const response = await fetch(url + '/AnalyzeTranscript', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        },
        body: JSON.stringify({
            transcript,
            llm_provider: llmProvider,
            include_detailed_report: includeDetailedReport,
            include_research: includeDetailedReport,
            entity_type: entity?.entityType,
            entity_id: entity?.entityId,
            entity_text_hash: entity?.entityTextHash
        })
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

export const ApplyIdeationSuggestion = async (idToken, ideaId, payload) => {
    const response = await fetch(url + '/Ideation/' + encodeURIComponent(ideaId) + '/ApplySuggestion', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        },
        body: JSON.stringify(payload || {})
    });

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

export const GetIdeationVersionText = async (idToken, ideaId, version) => {
    const response = await fetch(
        url + '/Ideation/' + encodeURIComponent(ideaId) + '/Versions/' + encodeURIComponent(version),
        {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'AccessToken': idToken
            }
        }
    );

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

export const RevertIdeationVersion = async (idToken, ideaId, version) => {
    const response = await fetch(
        url + '/Ideation/' + encodeURIComponent(ideaId) + '/Versions/' + encodeURIComponent(version) + '/Revert',
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'AccessToken': idToken
            },
            body: JSON.stringify({})
        }
    );

    const myJson = await response.json();
    var status = response.status;
    return { status, myJson };
};

// Workflow API methods

export const CreateWorkflow = async (idToken, workflowRequest) => {
    const response = await fetch(url + '/Workflow/Create', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        },
        body: JSON.stringify(workflowRequest)
    });

    const myJson = await response.json();
    const status = response.status;
    return { status, myJson };
};

export const GetWorkflow = async (idToken, workflowId) => {
    const response = await fetch(url + `/Workflow/${workflowId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json();
    const status = response.status;
    return { status, myJson };
};

export const ListWorkflows = async (idToken, lastId = null, limit = 10) => {
    const params = new URLSearchParams({
        limit: String(limit)
    });
    
    if (lastId) {
        params.append('last_id', lastId);
    }
    
    const response = await fetch(url + '/Workflow/List?' + params.toString(), {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        }
    });

    const myJson = await response.json();
    const status = response.status;
    return { status, myJson };
};

// Rename the project. The workspace picks up the same name; the idea keeps its
// own title.
export const RenameWorkflow = async (idToken, workflowId, name) => {
    const response = await fetch(url + `/Workflow/${workflowId}/Rename`, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        },
        body: JSON.stringify({ name })
    });

    const myJson = await response.json();
    const status = response.status;
    return { status, myJson };
};

// Manage workflow collaborators (owner only).
// request: { action: 'add'|'remove'|'update_role', email?|user_id?, role: 'viewer'|'editor' }
export const UpdateWorkflowCollaborators = async (idToken, workflowId, collaboratorRequest) => {
    const response = await fetch(url + `/Workflow/${workflowId}/Collaborators`, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        },
        body: JSON.stringify(collaboratorRequest)
    });

    const myJson = await response.json();
    const status = response.status;
    return { status, myJson };
};

export const FinalizeWorkflowStep = async (idToken, workflowId) => {
    const response = await fetch(url + `/Workflow/${workflowId}/Finalize`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        },
        body: JSON.stringify({})
    });

    const myJson = await response.json();
    const status = response.status;
    return { status, myJson };
};

// --- Video generation (script -> shots -> stitched cut) ---------------------
//
// Every call that costs money returns a queued job rather than a result; the UI
// polls GetVideoGeneration for progress. One shared helper below because these
// endpoints are numerous and otherwise identical in shape.

const generationRequest = async (idToken, method, path, body) => {
    const response = await fetch(url + path, {
        method,
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': idToken
        },
        body: body === undefined ? undefined : JSON.stringify(body)
    });

    const myJson = await response.json();
    const status = response.status;
    return { status, myJson };
};

// Multipart, so Content-Type is left to the browser: setting it by hand omits
// the boundary and the server cannot parse the body.
const generationUpload = async (idToken, path, formData) => {
    const response = await fetch(url + path, {
        method: 'POST',
        headers: { 'AccessToken': idToken },
        body: formData
    });

    const myJson = await response.json();
    const status = response.status;
    return { status, myJson };
};

export const StartVideoGeneration = async (idToken, startRequest) =>
    generationRequest(idToken, 'POST', '/VideoGeneration/Start', startRequest);

export const GetVideoGeneration = async (idToken, workspaceId) =>
    generationRequest(idToken, 'GET', `/VideoGeneration/${workspaceId}`);

export const UpdateVideoGeneration = async (idToken, workspaceId, updateRequest) =>
    generationRequest(idToken, 'PATCH', `/VideoGeneration/${workspaceId}`, updateRequest);

export const RebreakdownVideoGeneration = async (idToken, workspaceId) =>
    generationRequest(idToken, 'POST', `/VideoGeneration/${workspaceId}/Rebreakdown`, {});

export const CancelVideoGeneration = async (idToken, workspaceId) =>
    generationRequest(idToken, 'POST', `/VideoGeneration/${workspaceId}/Cancel`, {});

export const GenerateGenerationCharacters = async (idToken, workspaceId) =>
    generationRequest(idToken, 'POST', `/VideoGeneration/${workspaceId}/Characters/Generate`, {});

export const RegenerateGenerationCharacter = async (idToken, workspaceId, name) =>
    generationRequest(idToken, 'POST', `/VideoGeneration/${workspaceId}/Characters/${encodeURIComponent(name)}/Regenerate`, {});

export const UpdateGenerationCharacter = async (idToken, workspaceId, name, updateRequest) =>
    generationRequest(idToken, 'PATCH', `/VideoGeneration/${workspaceId}/Characters/${encodeURIComponent(name)}`, updateRequest);

export const ApproveGenerationCharacters = async (idToken, workspaceId) =>
    generationRequest(idToken, 'POST', `/VideoGeneration/${workspaceId}/Characters/Approve`, {});

export const UnapproveGenerationCharacters = async (idToken, workspaceId) =>
    generationRequest(idToken, 'POST', `/VideoGeneration/${workspaceId}/Characters/Unapprove`, {});

export const UploadGenerationCharacterImage = async (idToken, workspaceId, name, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return generationUpload(idToken, `/VideoGeneration/${workspaceId}/Characters/${encodeURIComponent(name)}/Upload`, formData);
};

export const SaveGenerationCharacterToLibrary = async (idToken, workspaceId, name) =>
    generationRequest(idToken, 'POST', `/VideoGeneration/${workspaceId}/Characters/${encodeURIComponent(name)}/SaveToLibrary`, {});

export const UseCastMemberForCharacter = async (idToken, workspaceId, name, castId) =>
    generationRequest(idToken, 'POST', `/VideoGeneration/${workspaceId}/Characters/${encodeURIComponent(name)}/UseCast/${castId}`, {});

// `force` false resumes -- shots that already have a take are left alone -- so
// it is the right default for a retry. Pass true only for a deliberate redo.
export const GenerateGenerationShots = async (idToken, workspaceId, fromIndex = 0, force = false) =>
    generationRequest(idToken, 'POST', `/VideoGeneration/${workspaceId}/Shots/Generate`, { FromIndex: fromIndex, Force: force });

export const RegenerateGenerationShot = async (idToken, workspaceId, index) =>
    generationRequest(idToken, 'POST', `/VideoGeneration/${workspaceId}/Shots/${index}/Regenerate`, {});

export const UpdateGenerationShot = async (idToken, workspaceId, index, updateRequest) =>
    generationRequest(idToken, 'PATCH', `/VideoGeneration/${workspaceId}/Shots/${index}`, updateRequest);

export const AddGenerationShot = async (idToken, workspaceId, addRequest) =>
    generationRequest(idToken, 'POST', `/VideoGeneration/${workspaceId}/Shots`, addRequest);

export const DeleteGenerationShot = async (idToken, workspaceId, index) =>
    generationRequest(idToken, 'DELETE', `/VideoGeneration/${workspaceId}/Shots/${index}`);

// Reordering renders nothing and costs nothing: takes are stored under the
// shot's own id, so a moved scene arrives with its video intact.
export const MoveGenerationShot = async (idToken, workspaceId, index, toIndex) =>
    generationRequest(idToken, 'POST', `/VideoGeneration/${workspaceId}/Shots/${index}/Move`, { ToIndex: toIndex });

// Running total for one project. Deliberately not date-ranged: a project's
// cost is its cost since it started, not since the first of the month.
export const GetWorkflowSpend = async (idToken, workflowId) =>
    generationRequest(idToken, 'GET', `/Workflow/${workflowId}/Spend`);

export const SelectGenerationTake = async (idToken, workspaceId, index, takeId) =>
    generationRequest(idToken, 'POST', `/VideoGeneration/${workspaceId}/Shots/${index}/SelectTake`, { TakeId: takeId });

export const StitchVideoGeneration = async (idToken, workspaceId) =>
    generationRequest(idToken, 'POST', `/VideoGeneration/${workspaceId}/Stitch`, {});

// --- Cast library (faces reused across projects) ----------------------------

export const GetCastLibrary = async (idToken) =>
    generationRequest(idToken, 'GET', '/CastLibrary');

export const GetCastMemberUrl = async (idToken, castId, download = false) =>
    generationRequest(idToken, 'GET', `/CastLibrary/${castId}/Url${download ? '?download=1' : ''}`);

export const UploadCastMember = async (idToken, { name, description = '', appearancePrompt = '', voicePrompt = '', tags = '', file }) => {
    const formData = new FormData();
    formData.append('Name', name);
    formData.append('Description', description);
    formData.append('AppearancePrompt', appearancePrompt);
    formData.append('VoicePrompt', voicePrompt);
    formData.append('Tags', tags);
    formData.append('file', file);
    return generationUpload(idToken, '/CastLibrary', formData);
};

export const UpdateCastMember = async (idToken, castId, updateRequest) =>
    generationRequest(idToken, 'PATCH', `/CastLibrary/${castId}`, updateRequest);

export const DeleteCastMember = async (idToken, castId) =>
    generationRequest(idToken, 'DELETE', `/CastLibrary/${castId}`);